// removed by extract-text-webpack-plugin
module.exports = {"comparison-price-container":"ComparisonPrice__comparison-price-container","comparisonPriceContainer":"ComparisonPrice__comparison-price-container","price-right":"ComparisonPrice__price-right","priceRight":"ComparisonPrice__price-right"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonPrice/ComparisonPrice.tablet.css
// module id = 1327
// module chunks = 8